"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataServerDate = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DATA_SERVER_DATE = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(:(\d{2})(\.\d+)?-?(\d{2}):(\d{2}))?/;
/**
 * Most browsers can natively parse the date string that DataServer returns, but IE does not appear to be able to, so let's do it manually!
 * @param val
 * @constructor
 */

var DataServerDate = function DataServerDate(val) {
  if (typeof val === 'undefined' || val === '') {
    return null;
  }

  if (val.includes(' ')) {
    return new Date(val);
  }

  var _val$match = val.match(DATA_SERVER_DATE),
      _val$match2 = _slicedToArray(_val$match, 11),
      year = _val$match2[1],
      month = _val$match2[2],
      day = _val$match2[3],
      hours = _val$match2[4],
      minutes = _val$match2[5],
      seconds = _val$match2[7],
      tzHours = _val$match2[9],
      tzMinutes = _val$match2[10];

  if (!seconds) {
    seconds = 0;
  }

  if (tzHours) {
    hours = Number(hours) + Number(tzHours);
  }

  if (tzMinutes) {
    minutes = Number(minutes) + Number(tzMinutes);
  }

  if (tzHours) {
    return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
  } else {
    return new Date(year, month - 1, day, hours, minutes, seconds);
  }
};

exports.DataServerDate = DataServerDate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/types/DataServerDate.js
// module id = 42
// module chunks = 0